import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import { useAuthContext } from '../contexts/AuthContext';
import { safeUserMessage } from '../utils/errorMessages';

const ForgotPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const { requestPasswordReset } = useAuthContext();
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await requestPasswordReset(email.trim());
      setSuccess(true);
    } catch (requestError) {
      setError(safeUserMessage(requestError, 'Unable to send password reset email. Please try again.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Forgot Password" subtitle="We will email a reset link to your inbox.">
      {success ? (
        <div className="space-y-4">
          <div className="rounded-lg border border-green-900 bg-green-950/30 p-4 text-sm text-green-300 mb-3">
            Reset instructions sent to <strong>{email}</strong>.
          </div>
          <Link to="/login" className="text-accent hover:text-accent-hover text-sm">
            Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={event => setEmail(event.target.value)}
            autoComplete="email"
            required
            className="w-full rounded-lg bg-secondary border border-gray-border px-4 py-3 text-white placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent"
          />

          {error && (
            <div className="text-sm text-red-400 bg-red-950/40 border border-red-900 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-accent text-primary hover:bg-accent-hover disabled:opacity-60 disabled:cursor-not-allowed px-4 py-3 font-semibold transition-colors"
          >
            {submitting ? 'Sending...' : 'Send reset email'}
          </button>

          <Link to="/login" className="text-sm text-text-muted hover:text-white block text-center">
            Back to sign in
          </Link>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
